const initialState = {
    searchIsActive: false,
    searchTerm: "",
    searchResults: null,
    error: null,
};

export default (state = initialState, action) => {
    switch(action.type){
        case "search/ONCHANGE_SEARCH":
            return {
                ...state,
                searchTerm: action.payload,
            };
        case "search/TOGGLE_ACTIVE_STATE":
            return {
                ...state,
                searchIsActive: true,
                searchResults: null,
            };
        case "search/CLEAR_SEARCH":
            return initialState;
        case "search/SEARCH_SUCCESS":
            return {
                ...state,
                searchResults: action.payload,
                error: null,
            };
        case "search/SEARCH_ERROR":
            return {
                ...state,
                error: action.payload,
                searchResults: null,
            };
        default:
            return state;
    }
};